import { all } from 'redux-saga/effects';
import { setConfig } from './analytics';
import { fetchCamList } from './camera';

export function* helloSaga() {
  console.log('helloSagas! from /sagas/index. via rootSaga');
}
export default function* rootSaga() {
  yield all([
    helloSaga(),
    setConfig(),
    // fetchCamList(),
  ]);
}
